import { IProjectSettings, IConfigLeanToConfig, IAddonSetting, IAccessorySetting } from "./IProjectSettings";
import { Collection } from "../utils/Collection";
import { SignalConfig } from "./SignalConfig";
import { LeanToConfig } from "./LeanToConfig";
import { InsetBayConfig } from "./InsetBayConfig";
import { SimpleSignal } from "../utils/SimpleSignal";
import { Main } from "../Main";
import { LeanToSettingConfig } from "./LeanToSettingConfig";
import { ObjectUtils } from "../utils/data/ObjectUtils";
import { Group } from "three";
import { RidgeVent } from "../scene/extras/RidgeVent";

export class Config
{
	//public static WIDTH = "width";

	public static COLOR_ROLLUP = "rollUp";
	public static COLOR_VENT = "vent";

	public config: any;

	public gltfScene: Group;

	public building: BuildingModel;
	public accessories: Accessories;

	public colorCollection: Collection<any>;
	public colors: ColorsConfig;

	public projectSettings: IProjectSettings;

	private _isProjectSettingsBeingSet: boolean = false;

	public metrics:IBuildingMetrics = {
		width: 0,
		width_max: 0,
		width_half: 0,

		length: 0,
		length_max: 0,
		length_half: 0,

		height: 0,
		height_half: 0,
		height_left: 0,
		height_right: 0,

		overhang_front: 0,
		overhang_back: 0,
		overhang_left: 0,
		overhang_right: 0,
		overhang_offset_left: 0,
		overhang_offset_right: 0,

		pitch: 0,
		tan: 0, // pitch / 12
		alpha: 0, // Math.atan(tan)
		roof_height: 0, // tan * width_half
		top: 0  // height + roof_height
	};

	constructor(config:any)
	{
		this.config = config;
		this.initBuilding();
		this.initAccessories();
		this.initColors();
		this.updateMetrics();
	}

	private initWallLinerPanelsConfig()
	{
		const config = this.config.wallLinerPanels;
		const colors = this.config.colors.values;

		config.fields[0].type = "color";

		//config.fields[0].values[0].code = "0";
		config.fields[0].values[0].id = "none";
		config.fields[0].values[0].hex = "#ffffff";

		for (const value of config.fields[0].values)
		{
			for (const color of colors)
			{
				if (color.label === value.label)
				{
					//value.code = value.id;
					//value.id = color.id;
					value.id = `${color.id}`;
					value.hex = color.hex;
					value.nested = color.nested;
					break;
				}
			}
		}

		config.fields[0].value = "none";

		return new Collection(config.fields, "id");
	}

	private initBuilding()
	{

		const buildingConfig           = new Collection(this.config.building.fields, "id");
		const overhangConfig           = new Collection(this.config.overhang.fields, "id");
		const ridgeVentConfig          = new Collection(this.config.ridge_vent.fields, "id");
		const wainscotConfig           = new Collection(this.config.wainscot.fields, "id");
		const gutterConfig             = new Collection(this.config.gutter.fields, "id");
		const supportBeamConfig        = new Collection(this.config.supportBeam.fields, "id");
		const insulationConfig         = new Collection(this.config.insulation.fields, "id");
		const translucentPanelsConfig  = new Collection(this.config.translucentPanels.fields, "id");

		const wallLinerPanelsConfig    = this.initWallLinerPanelsConfig();

		if (this.config.insetbay == null)
		{
			
		}
		
		this.building = {
			width            : new SignalConfig<number>(buildingConfig.getByKey("width")),
			length           : new SignalConfig<number>(buildingConfig.getByKey("length")),
			height           : new SignalConfig<number>(buildingConfig.getByKey("height")),
			pitch            : new SignalConfig<number>(buildingConfig.getByKey("pitch")),
 
			overhang_sides   : new SignalConfig<number>(overhangConfig.getByKey("overhang_sides")),
			overhang_end     : new SignalConfig<number>(overhangConfig.getByKey("overhang_end")),

			// overhang_front  : new SignalConfig<number>(overhangConfig.getByKey("overhang_front")),
			// overhang_back   : new SignalConfig<number>(overhangConfig.getByKey("overhang_back")),
			// overhang_left   : new SignalConfig<number>(overhangConfig.getByKey("overhang_left")),
			// overhang_right  : new SignalConfig<number>(overhangConfig.getByKey("overhang_right")),

			no_walls         : new SignalConfig<boolean>(buildingConfig.getByKey("no_walls")),
			single_slope     : new SignalConfig<boolean>(buildingConfig.getByKey("single_slope") || false),
 
			ridge_vent_type  : new SignalConfig<string>(ridgeVentConfig.getByKey("ridge_vent_type")),
			ridge_vent_mode  : new SignalConfig<boolean>(ridgeVentConfig.getByKey("ridge_vent_mode")),
 
			wainscot         : new SignalConfig<number>(wainscotConfig.getByKey("wainscot")),
			gutter           : new SignalConfig<boolean>(gutterConfig.getByKey("gutter")),
			supportBeam      : new SignalConfig<boolean>(supportBeamConfig.getByKey("supportBeam")),
			leanto           : new LeanToConfig(this.config.leanto),
			insetBay         : new InsetBayConfig(this.config.insetbay),
 
			addons           : this.config.addons,
 
			insulation       : new SignalConfig<string>(insulationConfig.getByKey("insulation") || "no"),
			translucentPanels: new SignalConfig<number>(translucentPanelsConfig.getByKey("translucent_panels") || 0),
			wallLinerPanels  : new SignalConfig<string>(wallLinerPanelsConfig.getByKey("wall_liner_panels")),

			// derived
			sizeChange       : new SimpleSignal(),
			roofChange       : new SimpleSignal(),
			propertyChange   : new SimpleSignal()
		};

		// derived values

		// any property

		this.building.width.signal.add(this.onPropertyChange);
		this.building.length.signal.add(this.onPropertyChange);
		this.building.height.signal.add(this.onPropertyChange);

		this.building.pitch.signal.add(this.onPropertyChange);
		this.building.overhang_sides.signal.add(this.onPropertyChange);
		this.building.overhang_end.signal.add(this.onPropertyChange);
		// this.building.overhang_front.signal.add(this.onPropertyChange);
		// this.building.overhang_back.signal.add(this.onPropertyChange);
		// this.building.overhang_left.signal.add(this.onPropertyChange);
		// this.building.overhang_right.signal.add(this.onPropertyChange);

		// size

		this.building.width.signal.add(this.onSizeChange);
		this.building.length.signal.add(this.onSizeChange);
		this.building.height.signal.add(this.onSizeChange);

		// roof

		this.building.pitch.signal.add(this.onRoofChange);
		this.building.overhang_sides.signal.add(this.onRoofChange);
		this.building.overhang_end.signal.add(this.onRoofChange);
		// this.building.overhang_front.signal.add(this.onRoofChange);
		// this.building.overhang_back.signal.add(this.onRoofChange);
		// this.building.overhang_left.signal.add(this.onRoofChange);
		// this.building.overhang_right.signal.add(this.onRoofChange);
	}

	private initAccessories()
	{
		this.accessories = {
			change: new SimpleSignal(),
			accessories: this.config.accessories
		}
	}

	private onPropertyChange = () =>
	{
		this.updateMetrics();

		this.building.propertyChange.dispatch();
	};

	private onSizeChange = () =>
	{
		this.building.sizeChange.dispatch();
	};

	private onRoofChange = () =>
	{
		this.building.roofChange.dispatch();
	};

	private initColors()
	{
		this.colorCollection = new Collection(this.config.colors.values);
		//var colorFields = this.config.colors.fields.slice(0);
		//colorFields.push(this.config.ridge_vent.fields[2]);

		var colorFields = new Collection(this.config.colors.fields, "id");

		var ridgeVentConfig = new Collection(this.config.ridge_vent.fields, "id");
		var wainscotConfig  = new Collection(this.config.wainscot.fields, "id");

		this.colors = {
			wall     : new SignalConfig<string>(colorFields.getByKey("color_wall")),
			roof     : new SignalConfig<string>(colorFields.getByKey("color_roof")),
			trim     : new SignalConfig<string>(colorFields.getByKey("color_trim")),
			rollUp   : new SignalConfig<string>(colorFields.getByKey("color_rollUp")),
			wainscot : new SignalConfig<string>(colorFields.getByKey("color_wainscot")),
			vent     : new SignalConfig<string>(colorFields.getByKey("color_vent"))
		};

		// this can be used if colors are stored by their id (instead of hex)
		/*
		this.colors = {
			wall     : this.getColorConfigByField(colorFields.getByKey("color_wall")),
			roof     : this.getColorConfigByField(colorFields.getByKey("color_roof")),
			trim     : this.getColorConfigByField(colorFields.getByKey("color_trim")),
			rollUp   : this.getColorConfigByField(colorFields.getByKey("color_rollUp")),
			vent     : this.getColorConfigByField(ridgeVentConfig.getByKey("color_vent")),
			wainscot : this.getColorConfigByField(wainscotConfig.getByKey("color_wainscot"))
		};
		*/
	}

	private getColorConfigByField(fieldConfig:{value:string})
	{
		var colorId = fieldConfig.value;
		var color = this.colorCollection.getByKey(colorId);

		if (!color)
		{
			console.log("Color not found:" + colorId);
			return null;
		}

		return new SignalConfig<string>({
			value: color.hex
		});
	}

	private updateMetrics()
	{
		var metrics = this.metrics;
		var buildingConfig = this.building;

		metrics.width = buildingConfig.width.value;
		metrics.width_half = metrics.width / 2;
		metrics.width_max = buildingConfig.width.max;

		metrics.length = buildingConfig.length.value;
		metrics.length_half = metrics.length / 2;
		metrics.length_max = buildingConfig.length.max;

		metrics.height = buildingConfig.height.value;
		metrics.height_half = metrics.height / 2;

		metrics.pitch = buildingConfig.pitch.value;
		metrics.tan = metrics.pitch / 12;
		metrics.alpha = Math.atan(metrics.tan);
		metrics.roof_height = metrics.tan * metrics.width_half;
		metrics.top = metrics.height + metrics.roof_height;

		var single_slope = buildingConfig.single_slope.value;
		if (single_slope && single_slope)
		{
			var slope_height =  metrics.height + metrics.width_half * metrics.tan * 2;

			//if (single_slope === "left")
			//{
			//	metrics.height_left = slope_height;
			//}
			//else if (single_slope)
			{
				metrics.height_right = slope_height;
			}
		}

		metrics.overhang_front = buildingConfig.overhang_end.value;
		metrics.overhang_back  = buildingConfig.overhang_end.value;
		metrics.overhang_left  = buildingConfig.overhang_sides.value;
		metrics.overhang_right = buildingConfig.overhang_sides.value;

		// metrics.overhang_front = buildingConfig.overhang_front.value;
		// metrics.overhang_back  = buildingConfig.overhang_back.value;
		// metrics.overhang_left  = buildingConfig.overhang_left.value;
		// metrics.overhang_right = buildingConfig.overhang_right.value;
		metrics.overhang_offset_left  = metrics.overhang_left  * metrics.tan;
		metrics.overhang_offset_right = metrics.overhang_right * metrics.tan;
	}

	public setProjectSettings(projectSetting:IProjectSettings)
	{
		this._isProjectSettingsBeingSet = true;

		this.projectSettings = projectSetting;

		const building = this.building;
		Main.getInstance().scene.building.leanToManager.removeListeners();
		building.width.setValue(projectSetting.building.width);
		building.length.setValue(projectSetting.building.length);
		building.height.setValue(projectSetting.building.height);
		building.pitch.setValue(projectSetting.building.pitch);
		var singleSlope = projectSetting.building.single_slope;
		if (singleSlope == null || (<any>singleSlope as string) === "none")
		{
			singleSlope = false;
		}
		building.single_slope.setValue(singleSlope);

		building.overhang_sides.setValue(projectSetting.building.overhang_sides);
		building.overhang_end.setValue(projectSetting.building.overhang_end);
		// building.overhang_front.setValue(projectSetting.building.overhang_front);
		// building.overhang_back.setValue(projectSetting.building.overhang_back);
		// building.overhang_left.setValue(projectSetting.building.overhang_left);
		// building.overhang_right.setValue(projectSetting.building.overhang_right);

		building.insulation.setValue(projectSetting.insulation || "no");
		building.translucentPanels.setValue(projectSetting.translucentPanels || 0);
		building.wallLinerPanels.setValue(projectSetting.wallLinerPanels || "none");

		building.no_walls.setValue(projectSetting.building.no_walls);

		building.ridge_vent_type.setValue(projectSetting.building.ridge_vent_type);
		building.ridge_vent_mode.setValue(projectSetting.building.ridge_vent_mode === RidgeVent.MODE_EVEN);

		building.wainscot.setValue(projectSetting.wainscot);

		building.gutter.setValue(projectSetting.gutter);

		if (projectSetting.insetbay == null)
		{
			projectSetting.insetbay = {
				front: {
					count: 0,
					length_1: 20,
					length_2: 20
				},
				back: {
					count: 0,
					length_1: 20,
					length_2: 20
				}
			}
		}

		building.insetBay.front.count.setValue(projectSetting.insetbay.front.count);
		//building.insetBay.front.drop.setValue(projectSetting.insetbay.front.drop);
		building.insetBay.front.length_1.setValue(projectSetting.insetbay.front.length_1);
		building.insetBay.front.length_2.setValue(projectSetting.insetbay.front.length_2);
		//building.insetBay.front.overhang.setValue(projectSetting.insetbay.front.overhang);

		building.insetBay.back.count.setValue(projectSetting.insetbay.back.count);
		//building.insetBay.back.drop.setValue(projectSetting.insetbay.back.drop);
		building.insetBay.back.length_1.setValue(projectSetting.insetbay.back.length_1);
		building.insetBay.back.length_2.setValue(projectSetting.insetbay.back.length_2);
		//building.insetBay.back.overhang.setValue(projectSetting.insetbay.back.overhang);

		Main.getInstance().scene.building.leanToManager.addListeners();

		this.setLeanToConfig(building.leanto.back,  projectSetting.leanto.back);
		this.setLeanToConfig(building.leanto.front, projectSetting.leanto.front);
		this.setLeanToConfig(building.leanto.left,  projectSetting.leanto.left);
		this.setLeanToConfig(building.leanto.right, projectSetting.leanto.right);

		building.leanto.wraparound_front_left.enabled.setValue(projectSetting.leanto.wraparound_front_left);
		building.leanto.wraparound_front_right.enabled.setValue(projectSetting.leanto.wraparound_front_right);
		building.leanto.wraparound_back_left.enabled.setValue(projectSetting.leanto.wraparound_back_left);
		building.leanto.wraparound_back_right.enabled.setValue(projectSetting.leanto.wraparound_back_right);

		const wallValue = (projectSetting.leanto.wall as any as string) === "off" || projectSetting.leanto.wall == false ? false : true;
		building.leanto.wall.setValue(wallValue);

		this.accessories.accessories = projectSetting.accessories;
		this.accessories.change.dispatch();

		var colorSettings = projectSetting.colors;

		this.colors.wall.setValue(colorSettings.wall);
		this.colors.roof.setValue(colorSettings.roof);
		this.colors.trim.setValue(colorSettings.trim);
		this.colors.rollUp.setValue(colorSettings.rollUp);
		this.colors.vent.setValue(colorSettings.vent);
		this.colors.wainscot.setValue(colorSettings.wainscot);

		this._isProjectSettingsBeingSet = false;
	}

	private setLeanToConfig(config: LeanToSettingConfig, projectSetting: IConfigLeanToConfig)
	{
		config.enabled.setValue(projectSetting.enabled);
		config.drop.setValue(projectSetting.drop);

		config.cut_front.setValue(projectSetting.cut_front || 0);
		config.cut_back.setValue(projectSetting.cut_back || 0);

		config.length.setValue(projectSetting.length);
		config.pitch.setValue(projectSetting.pitch);
	}

	/**
	 * Compares current config with project settings to see if
	 * everything is saved (true) or there are unsaved changes (false).
	 * @param projectSettings
	 */
	public isSaved(projectSettings:IProjectSettings)
	{
		var currentSettings = this.save();

		return ObjectUtils.compare(projectSettings, currentSettings);
	}

	/**
	 * Convert the current config values to a json string.
	 */
	public save():IProjectSettings
	{
		var building = this.building;
		var colors   = this.colors;

		var config: IProjectSettings = {

			building: {
				width  : building.width.value,
				length : building.length.value,
				height : building.height.value,
				pitch  : building.pitch.value,

				overhang_sides: building.overhang_sides.value,
				overhang_end: building.overhang_end.value,
				// overhang_front : building.overhang_front.value,
				// overhang_back : building.overhang_back.value,
				// overhang_left : building.overhang_left.value,
				// overhang_right : building.overhang_right.value,

				no_walls : building.no_walls.value,
				single_slope : building.single_slope.value,

				ridge_vent_type : building.ridge_vent_type.value,
				ridge_vent_mode : building.ridge_vent_mode.value ? RidgeVent.MODE_EVEN : RidgeVent.MODE_CONTINUOUS
			},

			wainscot : building.wainscot.value,

			gutter: building.gutter.value,

			insetbay: {
				front: {
					count   : building.insetBay.front.count.value,
					//drop    : building.insetBay.front.drop.value,
					length_1: building.insetBay.front.length_1.value,
					length_2: building.insetBay.front.length_2.value,
					//overhang: building.insetBay.front.overhang.value
				},
				back: {
					count   : building.insetBay.back.count.value,
					//drop    : building.insetBay.back.drop.value,
					length_1: building.insetBay.back.length_1.value,
					length_2: building.insetBay.back.length_2.value,
					//overhang: building.insetBay.back.overhang.value
				}
			},

			leanto: {
				back  : this.convertLeanToConfig(building.leanto.back),
				front : this.convertLeanToConfig(building.leanto.front),
				left  : this.convertLeanToConfig(building.leanto.left),
				right : this.convertLeanToConfig(building.leanto.right),

				wraparound_front_left  : building.leanto.wraparound_front_left.enabled.value,
				wraparound_front_right : building.leanto.wraparound_front_right.enabled.value,
				wraparound_back_left   : building.leanto.wraparound_back_left.enabled.value,
				wraparound_back_right  : building.leanto.wraparound_back_right.enabled.value,

				wall : building.leanto.wall.value
			},

			colors: {
				wall     : colors.wall.value,
				roof     : colors.roof.value,
				trim     : colors.trim.value,
				rollUp   : colors.rollUp.value,
				vent     : colors.vent.value,
				wainscot : colors.wainscot.value
			},

			insulation: building.insulation.value,
			translucentPanels: building.translucentPanels.value,
			wallLinerPanels: building.wallLinerPanels.value,

			addons: Main.getInstance().scene.getAddonsForSave(),
			accessories: Main.getInstance().getAccessoryView().getAccessoriesForSave()
		};

		return config;
	}

	private convertLeanToConfig(leanto:LeanToSettingConfig):IConfigLeanToConfig
	{
		return {
			enabled   : leanto.enabled.value,
			length    : leanto.length.value,
			pitch     : leanto.pitch.value,
			drop      : leanto.drop.value,
			cut_front : leanto.cut_front.value,
			cut_back  : leanto.cut_back.value
		};
	}

	public get isProjectSettingsBeingSet()
	{
		return this._isProjectSettingsBeingSet;
	}
}

export class BuildingModel
{

	width            : SignalConfig<number>;
	length           : SignalConfig<number>;
	height           : SignalConfig<number>;
	pitch            : SignalConfig<number>;

	// overhang_front  : SignalConfig<number>;
	// overhang_back   : SignalConfig<number>;
	// overhang_left   : SignalConfig<number>;
	// overhang_right  : SignalConfig<number>;
	overhang_sides   : SignalConfig<number>;
	overhang_end     : SignalConfig<number>;
 
	no_walls         : SignalConfig<boolean>;
 
	single_slope     : SignalConfig<boolean>;
 
	ridge_vent_type  : SignalConfig<string>;
	ridge_vent_mode  : SignalConfig<boolean>; // is evenly spread (true), or continuous (false)
 
	wainscot         : SignalConfig<number>;
	gutter           : SignalConfig<boolean>;
	supportBeam      : SignalConfig<boolean>;
	leanto           : LeanToConfig;
	insetBay         : InsetBayConfig;

	insulation       : SignalConfig<string>;
	translucentPanels: SignalConfig<number>;
	wallLinerPanels  : SignalConfig<string>;

	addons           : IAddonSetting[];

	sizeChange       : SimpleSignal;
	roofChange       : SimpleSignal;
	propertyChange   : SimpleSignal;
}

export class ColorsConfig
{
	wall     : SignalConfig<string>;
	roof     : SignalConfig<string>;
	trim     : SignalConfig<string>;
	rollUp   : SignalConfig<string>;
	vent     : SignalConfig<string>;
	wainscot : SignalConfig<string>;
}

export class Accessories
{
	change: SimpleSignal;
	accessories: IAccessorySetting[];
}

export interface IBuildingMetrics
{
	width: number;
	width_max: number;
	width_half: number;

	length: number;
	length_max: number;
	length_half: number;

	height: number;
	height_half: number;
	height_left: number;
	height_right: number;

	overhang_front: number;
	overhang_back: number;
	overhang_left: number;
	overhang_right: number;
	overhang_offset_left: number;
	overhang_offset_right: number;

	pitch: number;
	tan: number; // pitch / 12
	alpha: number; // Math.atan(tan)
	roof_height: number; // tan * width_half
	top: number;  // height + roof_height
}
